import Alert from '@mui/material/Alert';

const NotFoundPage = () => {
    return (
        <>
            <Alert icon={false} severity="warning">
                This page does not exist!
            </Alert>
        </>
    );
};

export default NotFoundPage;
